import InvestorContext from 'InvestorContext';
import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useBreadcrumbs } from '../context/BreadcrumbsManager';
import StyledSection from './styles/StyledSection';
import { StyledTypography } from './styles/styles';

export default function Breadcrumbs(props: React.ComponentProps<typeof StyledSection>) {
  const breadcrumbs = useBreadcrumbs();
  const location = useLocation();
  const investorContext = useContext(InvestorContext);

  // Don't show breadcrumbs if we're on a fund opportunity page and investors are still loading
  const isFundOpportunityPage =
    location.pathname.startsWith('/opportunities/') && location.pathname.split('/').length > 2; // has an ID

  // Safely check if loading function exists before calling it
  const isLoading = investorContext.loading && investorContext.loading();

  if (isFundOpportunityPage && isLoading) {
    return null;
  }

  if (breadcrumbs.length <= 1) {
    return null;
  }

  const { sx } = props;

  const breadcrumbsProps: React.ComponentProps<typeof StyledSection> = {
    tone: 'default',
    noTopPadding: true,
    noSidePaddingFrom: 'xs',
    bottomSpacing: 0,
    additionalClassName: 'react-Breadcrumbs',
    sx: {
      display: { xs: 'none', md: 'flex' },
      flexWrap: 'wrap',
      alignItems: 'center',
      gap: '0.5rem',
      fontSize: '0.875rem',
      ...sx,
    },
    ...props,
  };

  return (
    <StyledSection {...breadcrumbsProps}>
      {breadcrumbs.map((breadcrumb, index) => (
        <React.Fragment key={index}>
          <StyledTypography
            sx={{
              fontWeight: 500,
            }}
          >
            <Link
              style={{
                color: 'inherit',
                textDecoration: 'none',
              }}
              to={breadcrumb.href}
            >
              {breadcrumb.label}
            </Link>
          </StyledTypography>

          {index < breadcrumbs.length - 1 && (
            <StyledTypography component="span" sx={{ mx: 0.5 }}>
              &gt;
            </StyledTypography>
          )}
        </React.Fragment>
      ))}
    </StyledSection>
  );
}
